export default __webpack_public_path__ + "static/media/IMG_6329.26ca41af.JPG";